import React, {useEffect, useState} from 'react';
import {FormGroup, CustomInput, Button, Spinner} from 'reactstrap';
import cx from 'classnames';

import {FormOtp, FormSubmit} from 'components/Forms';
import MuiIcon from 'components/Icons/MuiIcon';

import Login2FAAnotherMethod from './Login2FAAnotherMethod';
import useSendAlternateEmailGuard from './useSendAlternateEmailGuard';
import useVerifyEmailGuard from './useVerifyEmailGuard';

const CODE_LENGTH = 6;

function Login2FAAlternateEmailGuard(props) {
  const {session, enabledOTP, enabledEmail, onShowEmail, onShowAuth} = props;
  const {two_factor_session_id} = session || {};

  const [showAnother, setShowAnother] = useState(false);
  const [states, setStates] = useState({
    eg_code: '',
    remember_device: false,
  });

  useEffect(() => {
    return () => {
      setShowAnother(false);
      setStates({
        eg_code: '',
        remember_device: false,
      });
    };
  }, []);

  const {isSent, isSending, onResendEmailGuard} =
    useSendAlternateEmailGuard(session);
  const {isVerifying, onVerify} = useVerifyEmailGuard();

  function handleCodeChange(value) {
    setStates((prevStates) => ({...prevStates, eg_code: value || ''}));
  }

  function handleRememberChange(e) {
    const {checked} = e.target;
    setStates((prevStates) => ({...prevStates, remember_device: checked}));
  }

  if (showAnother) {
    return (
      <Login2FAAnotherMethod
        session={session}
        enabledOTP={enabledOTP}
        enabledEmail={enabledEmail}
        onShowAuth={onShowAuth}
        onShowEmail={onShowEmail}
        onBack={() => setShowAnother(false)}
      />
    );
  }

  const {eg_code} = states;

  return (
    <React.Fragment>
      <div className="text-center">
        <h1>2-Factor Authentication:</h1>
        <h1>Secondary email</h1>
        <p className="text-muted mb-0">
          We sent a verification code to your secondary email.
        </p>
        <p className="text-muted">
          Enter the code from email in the field below
        </p>
      </div>

      {isSending && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <Spinner />
        </div>
      )}

      <FormSubmit
        showSubmit={false}
        onSubmit={() => onVerify({...states, two_factor_session_id})}
        isSubmitting={isVerifying}
      >
        <fieldset disabled={isSending || isVerifying}>
          <FormOtp onChange={handleCodeChange} className="mb-4" />

          <FormGroup>
            <CustomInput
              id="remember"
              type="checkbox"
              label="Remember this device for 30 days"
              onChange={handleRememberChange}
            />
          </FormGroup>
          <Button
            block
            type="submit"
            color="primary"
            className="mb-3"
            disabled={isVerifying || eg_code.length < CODE_LENGTH}
          >
            {isVerifying ? (
              'Verifying...'
            ) : (
              <span>
                Continue <MuiIcon name="chevron_right" />
              </span>
            )}
          </Button>
        </fieldset>
      </FormSubmit>

      <div className="text-center">
        <p className="mb-1">
          Having trouble?{' '}
          <div
            className={cx('btn-link font-weight-normal d-inline', {
              disabled: isSent,
            })}
            style={{cursor: 'pointer'}}
            onClick={() => onResendEmailGuard()}
          >
            {isSent ? 'Sent' : 'Resend'}
          </div>
        </p>
        <p>
          <div
            className="btn-link font-weight-normal d-inline"
            style={{cursor: 'pointer'}}
            onClick={() => setShowAnother(true)}
          >
            Try another method
          </div>
        </p>
      </div>
    </React.Fragment>
  );
}

export default Login2FAAlternateEmailGuard;
